import fp from 'lodash/fp';

import { ErrorData } from './types';


export const isInfoError = (error: unknown): boolean =>
    fp.get('response.data.ErrorType', error) === 'Info' ||
    fp.get('response.data.errorType', error) === 'Info';

export const getErrorData = (error: unknown): ErrorData => ({
    title: fp.get('response.data.title', error) ?? fp.getOr(error, 'response.data.Title', error),
    text: fp.get('response.data.details', error) || null,
});
